// extracted by mini-css-extract-plugin
export var root = "k_Z";
export var wrapper = "k_b";
export var background = "k_v";
export var layer = "k_w";
export var column = "k_x";
export var moveRight = "k_B";
export var element = "k_r";
export var head = "k_bf";
export var heading = "k_G";
export var desc = "k_H";
export var faq = "k_bg";